// Optimizasyon (C13–C15, AI_OPTIMIZATION bayrağı): pano, senaryo karşılaştırma, öneri ve onay. Bayrak kapalıysa ekran
// hiç açılmaz (guard); izin modülü `optimization`.
import { Route } from 'react-router';
import { guard, load } from '../route-utils';

const OptimizationDashboard = load(() => import('./OptimizationDashboard'), 'OptimizationDashboard');
const ScenarioCompare = load(() => import('./ScenarioCompare'), 'ScenarioCompare');
const Recommendation = load(() => import('./Recommendation'), 'Recommendation');

const opts = { flag: 'AI_OPTIMIZATION' } as const;

export const optimizationRoutes = (
  <>
    <Route path="optimizasyon" element={guard(OptimizationDashboard, 'optimization', opts)} />
    <Route path="optimizasyon/:runId/karsilastir" element={guard(ScenarioCompare, 'optimization', opts)} />
    <Route path="optimizasyon/:runId/oneri" element={guard(Recommendation, 'optimization', opts)} />
  </>
);
